// Is this a development session? Those start silent — music autoplaying in every dev boot is a
// nuisance, and a volume saved by an earlier session used to resurrect it.
//
// Silent when ANY of these holds:
//   - a Vite dev build (`import.meta.env.DEV`);
//   - `VITE_AOD_SILENT=1` (for a production build served locally, e.g. `vite preview`, where
//     DEV is false);
//   - the page is served from localhost / 127.0.0.1 / ::1 (the native shells use their own
//     hostname, so a store build never matches).
// `VITE_AOD_SILENT=0` forces sound on in any of the above, for working on the audio itself.

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

export function isDevSilent(): boolean {
  const flag = import.meta.env.VITE_AOD_SILENT;
  if (flag === '0') return false;
  if (flag === '1') return true;
  if (import.meta.env.DEV) return true;
  const host = globalThis.location?.hostname;
  return typeof host === 'string' && LOCAL_HOSTS.has(host);
}
